/* albm-faq.js — <albm-faq-groups> · OWNER: T7
   Biến nội dung Q&A viết sẵn trong `page.content` thành accordion <details> giống bản ALBUM.

   Markup do sections/albm-faq-index.liquid sinh (chế độ NỘI DUNG):
     <albm-faq-groups class="albm-grid albm-qa__grid">
       <div class="albm-qa__card" data-tab="g1">
         <h2 class="albm-qa__card-title" id="AlbmQaGroup-…">配送・送料について</h2>
         <div class="albm-rte albm-qa__qa" data-albm-acc-name="AlbmQa-…">
           <p><strong>Q. 送料はいくらかかりますか。</strong><br>A. 全国送料無料です。</p>
           <ul>…</ul>
         </div>
       </div>
     </albm-faq-groups>

   Quy tắc gom: mỗi <p> mở đầu bằng <strong>Q…</strong> thành 1 <details>; các phần tử
   ngay sau đó (<ul>/<ol>/<p> thường) được đưa vào phần trả lời của <details> gần nhất.
   Nội dung đứng TRƯỚC câu hỏi đầu tiên (đoạn dẫn, danh sách thuần) giữ nguyên tại chỗ.
   Không có câu hỏi nào trong nhóm → giữ nguyên toàn bộ, vẫn đọc được như trang tĩnh.
*/
const ALBM_FAQ_Q = /^\s*Q\s*[.．。:：、]?\s*/;
const ALBM_FAQ_A = /^\s*A\s*[.．。:：、]?\s*/;

class AlbmFaqGroups extends HTMLElement {
  connectedCallback() {
    if (this.dataset.albmFaqReady === 'true') return;
    this.dataset.albmFaqReady = 'true';
    this.querySelectorAll('.albm-qa__qa').forEach((box) => AlbmFaqGroups.build(box));
  }

  static build(box) {
    const accName = box.dataset.albmAccName || '';
    const nodes = Array.from(box.children);
    let current = null;

    nodes.forEach((el) => {
      const strong = el.tagName === 'P' ? el.querySelector(':scope > strong') : null;
      if (strong && ALBM_FAQ_Q.test(strong.textContent)) {
        current = AlbmFaqGroups.toDetails(el, strong, accName);
        box.insertBefore(current, el);
        el.remove();
        return;
      }
      if (current) {
        current.lastElementChild.appendChild(el);
      }
    });
  }

  /** <p><strong>Q. …</strong><br>A. …</p> → <details> */
  static toDetails(paragraph, strong, accName) {
    const details = document.createElement('details');
    details.className = 'albm-accordion__item albm-qa__item';
    if (accName) details.setAttribute('name', accName);

    const summary = document.createElement('summary');
    summary.className = 'albm-accordion__summary';

    const title = document.createElement('h3');
    title.className = 'albm-accordion__title';
    title.textContent = strong.textContent.replace(ALBM_FAQ_Q, '').trim();
    summary.appendChild(title);

    const icon = document.createElement('span');
    icon.className = 'albm-accordion__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = '<span class="albm-accordion__icon-h"></span><span class="albm-accordion__icon-v"></span>';
    summary.appendChild(icon);

    const content = document.createElement('div');
    content.className = 'albm-accordion__content albm-rte';

    const answer = document.createElement('p');
    const kids = Array.from(paragraph.childNodes);
    let started = false;
    kids.slice(kids.indexOf(strong) + 1).forEach((node) => {
      const blankText = node.nodeType === Node.TEXT_NODE && !node.textContent.trim();
      if (!started && (node.nodeName === 'BR' || blankText)) return;
      started = true;
      answer.appendChild(node);
    });
    const head = answer.firstChild;
    if (head && head.nodeType === Node.TEXT_NODE) {
      head.textContent = head.textContent.replace(ALBM_FAQ_A, '');
    }
    if (answer.textContent.trim() || answer.children.length) content.appendChild(answer);

    details.appendChild(summary);
    details.appendChild(content);
    return details;
  }
}

if (!customElements.get('albm-faq-groups')) {
  customElements.define('albm-faq-groups', AlbmFaqGroups);
}
